import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=7a4a0e94"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=7a4a0e94&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4a0e94')) {
      api.createRecord('7a4a0e94', component.options)
    } else {
      api.reload('7a4a0e94', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=7a4a0e94", function () {
      api.rerender('7a4a0e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/widget/Product.vue"
export default component.exports